import {RecurrentSequenceConfig, ScheduledSequenceConfig} from '../sequence';

export class SequencePersistRequest {
  uuid: string;
  name: string;
  tenantUuid: string;
  organizationUuid: string;
  recurrentSequenceConfig: RecurrentSequenceConfig;
  scheduledSequenceConfig: ScheduledSequenceConfig;
  configuration: any;
}
